module.exports = __webpack_public_path__ + "assets/Crossbite selected.b1eb63817e670ebd674eb6a723b1e08e.png";